"use client";

import React from "react";
import { Search, Funnel } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
export default function AggiornamentiEApprofondimenti() {
  return <section id="aggiornamenti-e-approfondimenti" className="relative bg-background py-24 md:py-32 overflow-hidden border-b border-border">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20 pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 border border-primary/20 bg-primary/5 text-primary text-sm font-medium tracking-wide uppercase">
            <span className="size-2 bg-primary"></span>
            Studio MESS S.r.l.
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tight mb-6">
            Aggiornamenti e Normative
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto">
            Aggiornamenti continui sulle normative di sicurezza e ingegneria. Resta informato sulle ultime novità del settore per garantire la conformità della tua azienda.
          </p>

          {}
          <div className="bg-card border border-border shadow-sm p-2 flex flex-col md:flex-row gap-2 max-w-3xl mx-auto">
            <div className="relative flex-1 flex items-center">
              <Search className="absolute left-3 size-5 text-muted-foreground" />
              <Input type="text" placeholder="Cerca articoli, normative, parole chiave..." className="pl-10 border-none bg-transparent shadow-none focus-visible:ring-0 h-12 text-base" />
            </div>
            
            <div className="h-px md:h-12 w-full md:w-px bg-border hidden md:block"></div>
            
            <div className="w-full md:w-[220px] flex items-center border-t md:border-t-0 border-border pt-2 md:pt-0">
              <Funnel className="ml-3 size-4 text-muted-foreground hidden md:block" />
              <Select defaultValue="tutte">
                <SelectTrigger className="w-full border-none bg-transparent shadow-none focus:ring-0 h-12 text-base">
                  <SelectValue placeholder="Seleziona Categoria" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="tutte">Tutte le categorie</SelectItem>
                  <SelectItem value="sicurezza">Sicurezza sul Lavoro</SelectItem>
                  <SelectItem value="ingegneria">Ingegneria</SelectItem>
                  <SelectItem value="lombardia">News Lombardia</SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            <Button size="lg" className="w-full md:w-auto h-12 px-8 text-base">
              Cerca
            </Button>
          </div>
          
          <div className="mt-6 flex flex-wrap justify-center gap-2 text-sm text-muted-foreground">
            <span>Ricerche frequenti:</span>
            <Button variant="ghost" size="sm" className="h-auto p-0 text-muted-foreground hover:text-primary underline underline-offset-4">
              D.Lgs 81/08
            </Button>
            <span className="text-border">•</span>
            <Button variant="ghost" size="sm" className="h-auto p-0 text-muted-foreground hover:text-primary underline underline-offset-4">
              RSPP
            </Button>
            <span className="text-border">•</span>
            <Button variant="ghost" size="sm" className="h-auto p-0 text-muted-foreground hover:text-primary underline underline-offset-4">
              Cantieri
            </Button>
            <span className="text-border">•</span>
            <Button variant="ghost" size="sm" className="h-auto p-0 text-muted-foreground hover:text-primary underline underline-offset-4">
              Antincendio
            </Button>
          </div>
        </div>
      </div>
    </section>;
}